import { PaintBrush, Plant, Star, Sun, Heart, Cloud } from "@phosphor-icons/react";
import { SectionShell, Panel } from "../Primitives";
import { Mascot } from "../Mascot";

const PRINCIPLES = [
  { t: "Flat & rounded", d: "Soft organic shapes, no harsh outlines or heavy detail." },
  { t: "Warm & inclusive", d: "Joyful, diverse characters that every child sees themselves in." },
  { t: "Purposeful", d: "Illustration explains and rewards — it never just decorates." },
  { t: "Grows up", d: "Playful and bold for Year 1; refined and confident by Year 6." },
];

export function IllustrationSection() {
  return (
    <SectionShell
      id="illustration"
      eyebrow="Illustration"
      eyebrowIcon={PaintBrush}
      title="Meet Bloom, a sprout that grows"
      description="A single mascot anchors the brand: a friendly sprout that 'blooms' as children progress. Built from soft geometric shapes, it stays charming for little ones yet refined enough never to feel babyish."
    >
      <div className="grid gap-5 lg:grid-cols-[0.9fr_1.1fr]">
        <Panel className="flex flex-col items-center justify-center bg-gradient-to-b from-accent/70 to-card text-center">
          <Mascot size={180} />
          <p className="mt-4 font-display text-2xl font-extrabold">Bloom</p>
          <p className="font-semibold text-muted-foreground">The brand mascot</p>
          <div className="mt-5 flex gap-3">
            {[Plant, Star, Sun, Heart, Cloud].map((Icon, i) => (
              <span key={i} className="flex h-11 w-11 items-center justify-center rounded-2xl bg-card text-primary shadow-soft">
                <Icon size={22} weight="fill" />
              </span>
            ))}
          </div>
        </Panel>

        <div className="grid gap-4 sm:grid-cols-2">
          {PRINCIPLES.map((p) => (
            <div key={p.t} className="rounded-3xl border border-border bg-card p-6 shadow-soft">
              <p className="font-display text-lg font-extrabold text-primary-strong">{p.t}</p>
              <p className="mt-2 font-medium leading-relaxed text-muted-foreground">{p.d}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-5 rounded-3xl border border-border bg-card p-6 shadow-soft md:p-8">
        <p className="mb-4 text-sm font-bold uppercase tracking-wider text-muted-foreground">Shape & colour kit</p>
        <div className="flex flex-wrap gap-4">
          <div className="h-16 w-16 rounded-full bg-primary" />
          <div className="h-16 w-16 rounded-3xl bg-secondary" />
          <div className="h-16 w-16 rounded-[40%_60%_55%_45%/55%_45%_55%_45%] bg-teal" />
          <div className="h-16 w-24 rounded-full bg-blue" />
          <div className="h-16 w-16 rotate-12 rounded-3xl bg-primary/30" />
          <div className="h-16 w-16 rounded-[60%_40%_30%_70%/60%_30%_70%_40%] bg-secondary/60" />
        </div>
        <p className="mt-4 font-medium leading-relaxed text-muted-foreground">
          Illustrations are assembled from these rounded primitives in brand colours — keeping a cohesive look across
          every lesson, reward and empty state.
        </p>
      </div>
    </SectionShell>
  );
}

export default IllustrationSection;
